//#region ../../node_modules/.pnpm/@mui+system@7.3.9_@emotion+react@11.14.0_@types+react@19.2.14_react@19.2.4__@emotion+st_bd245af145176c4b13a339c35b364ace/node_modules/@mui/system/esm/createBreakpoints/createBreakpoints.js
var e = (e) => {
	let t = Object.keys(e).map((t) => ({
		key: t,
		val: e[t]
	})) || [];
	return t.sort((e, t) => e.val - t.val), t.reduce((e, t) => ({
		...e,
		[t.key]: t.val
	}), {});
};
function t(t) {
	let { values: n = {
		xs: 0,
		sm: 600,
		md: 900,
		lg: 1200,
		xl: 1536
	}, unit: r = "px", step: i = 5, ...a } = t, o = e(n), s = Object.keys(o);
	function c(e) {
		return `@media (min-width:${typeof n[e] == "number" ? n[e] : e}${r})`;
	}
	function l(e) {
		return `@media (max-width:${(typeof n[e] == "number" ? n[e] : e) - i / 100}${r})`;
	}
	function u(e, t) {
		let a = s.indexOf(t);
		return `@media (min-width:${typeof n[e] == "number" ? n[e] : e}${r}) and (max-width:${(a !== -1 && typeof n[s[a]] == "number" ? n[s[a]] : t) - i / 100}${r})`;
	}
	function d(e) {
		return s.indexOf(e) + 1 < s.length ? u(e, s[s.indexOf(e) + 1]) : c(e);
	}
	function f(e) {
		let t = s.indexOf(e);
		return t === 0 ? c(s[1]) : t === s.length - 1 ? l(s[t]) : u(e, s[s.indexOf(e) + 1]).replace("@media", "@media not all and");
	}
	return {
		keys: s,
		values: o,
		up: c,
		down: l,
		between: u,
		only: d,
		not: f,
		unit: r,
		...a
	};
}
//#endregion
export { t as default };

//# sourceMappingURL=index28.js.map